module.exports = __webpack_public_path__ + "static/media/pam-boyd.e6e730ae.jpg";